import React, { useState, useEffect } from "react";
import { connect } from "formik";
import { compose } from "redux";
import { Grid } from "@material-ui/core";

import { LOAN_TYPE_LIST, INTEREST_RATE_TYPE_IDS } from "../loanProceedsConstants";
import { StyledAutoCompleteInput, StyledTextInput, StyledPercentInput } from "../styles";
import floatingIndexIds, { floatingIndexList } from "constants/floatingIndexes";

import FormSectionTitle from "./FormSectionTitle";

const LoanAssumptionsSection = props => {
  const { formik, interestRateTypes, fixedIndices } = props;
  const { values, setFieldTouched } = formik;
  const [rateIndexOptions, setRateIndexOptions] = useState([]);

  useEffect(() => {
    if (values?.interestRateType) {
      const formattedFloatingIndexList = floatingIndexList
        .filter(item => item.value !== floatingIndexIds.THIRTY_DAY_AVG_SOFR)
        .map(({ label, value }) => ({ label, value }));
      setRateIndexOptions(values.interestRateType === INTEREST_RATE_TYPE_IDS.FLOATING_RATE ? formattedFloatingIndexList : fixedIndices);
    }
  }, [values?.interestRateType]);

  if (!interestRateTypes) {
    return null;
  }

  const loanTypeListFiltered = LOAN_TYPE_LIST.filter(x => x.isAssumptionType);

  return (
    <>
      <Grid item xs={10}><FormSectionTitle title="LOAN ASSUMPTIONS" /></Grid>
      <Grid item xs={10}>
        <StyledAutoCompleteInput
          label="Loan Type"
          fieldName="loanType"
          selectValue="value"
          options={loanTypeListFiltered}
          onChange={e => {
            props.setLoanProceedAssumptions(e, props.formik); setFieldTouched("loanType", true);
          }}
        />
        {" "}
      </Grid>
      <Grid item xs={10}><StyledTextInput label="Term (m)" fieldName="loanTerm" /></Grid>
      <Grid item xs={10}><StyledTextInput label="Amort. Term (m)" fieldName="amortizationTerm" /></Grid>
      <Grid item xs={10}>
        <StyledAutoCompleteInput label="Interest Rate Type" fieldName="interestRateType" selectValue="value" options={interestRateTypes} />
        {" "}
      </Grid>
      <Grid item xs={10}>
        <StyledAutoCompleteInput label="Rate Index" fieldName="rateIndex" selectValue="value" options={rateIndexOptions} />
        {" "}
      </Grid>
      <Grid item xs={10}>
        <StyledPercentInput label="Spread" decimalScale={3} fieldName="spread" />
        {" "}
      </Grid>
      {values.interestRateType === INTEREST_RATE_TYPE_IDS.FLOATING_RATE && <Grid item xs={10}><StyledPercentInput label="Underwr. Rate (Floating)" decimalScale={3} fieldName="UwRate" /></Grid>}

    </>
  );
};
export default compose(connect)(LoanAssumptionsSection);
